<ion-item *ngIf="isOffline" lines="none">
    <ion-label color="light" class="ion-text-wrap">
        {{ 'no_internet_connection' | translate }}
    </ion-label>
</ion-item>